import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { Tracking } from 'web-core/src/tracking';
import TranslationProvider from 'client/components/translationProvider';
import App from './app';
import PrescriptionsPagecontainer from './prescriptionsPageContainer';

function bindPageViewTracking() {
  return () => {
    Tracking.trackPageView();
    Tracking.track('Landing Page Viewed', { Page: 'Prescriptions' });
  };
}

export default (
  <Route path="/" component={App}>
    <Route component={TranslationProvider} keys={['app', 'common']}>
      <IndexRoute component={PrescriptionsPagecontainer} onEnter={bindPageViewTracking()} />
    </Route>
  </Route>
);
